export default __webpack_public_path__ + "static/media/asterix_i_obelix.50796a6b.mp3";